<template>
  <div class="privacyStyle">
    <headerComponent @child-event="changePageContent" :loginType="loginType"></headerComponent>
    <div class="textContent">
      <iframe :src="pdfurl" frameborder="0"></iframe>
    </div>
  </div>
</template>
<script>
import headerComponent from "./header.vue";
export default {
  name: "",
  components: {
    headerComponent,
  },
  data() {
    return {
      hanshow: this.$route.params.type,
      pdfurl: null,
      publicPath: process.env.BASE_URL,
      loginType:''
    };
  },
  methods: {
    changePageContent(val) {
      const lang = val == "en" || val == "zh-CN" ? val : "en";
      if (this.hanshow == "cloud") {
        this.pdfurl = `${this.publicPath}static/hanshow_cloud_service_${lang}.html`;
      } else if (this.hanshow == "privacy") {
        this.pdfurl = `${this.publicPath}static/hanshow_privacy_policy_${lang}.html`;
      }
    },
  },
  created() {
    this.loginType=this.$route.params.loginType;
  },
  mounted() {
    this.changePageContent(this.$i18n.locale);
  },
  destroyed() {},
};
</script>
<style scoped lang="scss">
.privacyStyle {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
}
.textContent {
  width: 100%;
  flex: 1;
  overflow: hidden;
  iframe {
    width: 100%;
    height: 100%;
  }
}
</style>
